import { useEffect, useState } from "react";

import { List, Typography } from "@mui/material";
import TugSession from "data/firestore/tugSession";
import SessionListItem, { TugSessionData } from "../history/SessionListItem";
import CurrentSession from "data/userSession";
import AnalyticsService from "data/firestore/analytics";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ExpandableCard: any = require("components/ExpandableCard").default;

export interface RecentActivityProps {
  uid: string;
}

const RecentActivity = ({ uid }: RecentActivityProps) => {
  const [sessions, setSessions] = useState<TugSessionData[]>([]);
  // Viewing someone else's activity -> show their times in our timezone.
  const isOtherUser = !!uid && uid !== CurrentSession.user?.uid;

  const load = () => {
    TugSession.recent(uid).then((data: TugSessionData[]) => {
      setSessions(data);
    });
    AnalyticsService.event("recent_activity_card_expanded");
  };

  useEffect(() => {
    if (uid) {
      load();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uid]);

  return (
    <ExpandableCard
      title="Recent Activity"
      openedByDefault={false}
      onExpand={load}
    >
      {sessions.length === 0 ? (
        <Typography variant="overline">
          No completed tug sessions yet
        </Typography>
      ) : null}
      <List>
        {sessions.map((session) => (
          <SessionListItem
            key={session.id}
            session={session}
            clickable={true}
            localTime={isOtherUser}
          />
        ))}
      </List>
    </ExpandableCard>
  );
};

RecentActivity.displayName = "RecentActivity";

export default RecentActivity;
